export default "__VITE_PUBLIC_ASSET__42ec3f36__"